import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Smartphone, Upload } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      icon: Zap,
      title: "Launch fast (15 days)",
      description: "Ready processes and templates cut time-to-market so you're selling sooner."
    },
    {
      icon: Smartphone,
      title: "Designs that convert & load fast",
      description: "Tested product pages and speed-optimized themes for higher conversions."
    },
    {
      icon: Upload,
      title: "Extended product upload support",
      description: "We'll help upload and organize your catalog so launch is painless."
    }
  ];

  return (
    <section id="benefits" className="section" style={{ background: 'white' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px'
          }}>
            Why Choose Our 15-Day Launch?
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Three core advantages that get you selling faster
          </p>
        </motion.div>

        <div className="grid grid-3">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
              className="card"
              style={{
                textAlign: 'center',
                border: '2px solid #f1f5f9',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '20px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)'
              }}>
                <benefit.icon size={36} color="white" />
              </div>
              
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '16px'
              }}>
                {benefit.title}
              </h3>
              
              <p style={{
                fontSize: '1.125rem',
                color: '#64748b',
                lineHeight: '1.6'
              }}>
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
